import { render, staticRenderFns } from "./WithdrawCard.vue?vue&type=template&id=bccb20a8&scoped=true&"
import script from "./WithdrawCard.vue?vue&type=script&lang=js&"
export * from "./WithdrawCard.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawCard.vue?vue&type=style&index=0&id=bccb20a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccb20a8",
  null
  
)

export default component.exports